import React, { useEffect, useState } from 'react'
import * as PosService from '../../Services/pos-service'
import { Grid } from '@mui/material';
import CustomCheckBox from '../../Components/custom-checkbox/CustomCheckbox';

function PosRequestInfoCheck({ objectDto, setObjectDto, setLoading, lang, setValidate }) {
    const windowSize = PosService.getSizeWindows();
    const [changePersonalChecked, setChangePersonalChecked] = useState(0);
    const [changeContactChecked, setChangeContactChecked] = useState(0);
    const [changeFrequencyChecked, setChangeFrequencyChecked] = useState(0);
    useEffect(() => {
        if (objectDto !== undefined) {
            setChangeContactChecked(objectDto.changeContactChecked);
            setChangeFrequencyChecked(objectDto.changeFrequencyChecked);
            setChangePersonalChecked(objectDto.changePersonalChecked);
        }
    }, [objectDto]);

    return (
        <div className="col-md-12 form-group phl-border" id="cateDiv" style={{
            display: objectDto.checked === 1 ? "block" : "none", paddingBottom: "5px", paddingTop: "5px"
        }} >
            <Grid container spacing={1} alignItems="center" justifyContent="center" sx={{ paddingLeft: "10px", paddingRight: "10px" }}>
                <Grid item xs={12} sm={windowSize[0] > 991 ? 4 : 12} align="left">
                    <CustomCheckBox className="iCheck-checkbox" id="changeContact" title={lang('poschangecontact')} value={changeContactChecked === 1 ? true : false}
                        onChange={(e, v) => {
                            if (PosService.ValidateSearchInfoCheckbox(objectDto, setValidate) === true) {
                                setChangeContactChecked(e.target.checked ? 1 : 0);
                                PosService.HandleInfoCheckbox(objectDto, setObjectDto, 1, setLoading, e, v);
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={windowSize[0] > 991 ? 4 : 12} align="left">
                    <CustomCheckBox className="iCheck-checkbox" id="changePersonal" title={lang('poschangeinformation')} value={changePersonalChecked === 1 ? true : false}
                        onChange={(e, v) => {
                            if (PosService.ValidateSearchInfoCheckbox(objectDto, setValidate) === true) {
                                setChangePersonalChecked(e.target.checked ? 1 : 0);
                                PosService.HandleInfoCheckbox(objectDto, setObjectDto, 2, setLoading, e, v);
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={windowSize[0] > 991 ? 4 : 12} align="left">
                    <CustomCheckBox className="iCheck-checkbox" id="changeFrequency" title={lang('poschangefrequency')} value={changeFrequencyChecked === 1 ? true : false}
                        onChange={(e, v) => {
                            if (PosService.ValidateSearchInfoCheckbox(objectDto, setValidate) === true) {
                                setChangeFrequencyChecked(e.target.checked ? 1 : 0);
                                PosService.HandleInfoCheckbox(objectDto, setObjectDto, 3, setLoading, e, v);
                            }
                        }}
                    />
                </Grid>
            </Grid>
        </div>
    )
}

export default PosRequestInfoCheck